export const initGoogle = () => {
  const init = () => {
    window.google.accounts.id.initialize({
      auto_select: true,
      client_id: import.meta.env.VITE_GOOGLE_APP_ID,
      callback: (res: any) => {
        console.log(res);
        useHttp("/api/login", {
          method: "POST",
          body: {
            gToken: res.credential
          }
        }).then((res) => {
          console.log(res);
        });
      }
    });
  };
  return new Promise((resolve, reject) => {
    console.log(window.onGoogleLibraryLoad);
    if (window.onGoogleLibraryLoad) {
      return window.onGoogleLibraryLoad.then(() => resolve(undefined));
    }
    window.onGoogleLibraryLoad = new Promise((resolve) => {
      init();

      resolve(undefined);
    });
  });
};

//此方法用来检测是否有外网条件
export const checkGoogleAccess = () => {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), 2000);
  let p = useCustomizeFetch("https://accounts.google.com/gsi/status", {
    showLoading: true,
    signal: controller.signal
  })
    .then((res) => true)
    .catch(() => false);

  return p;
};
